// Angular dependencies
import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  HostBinding,
  ElementRef
} from '@angular/core';

// Store
import { Store } from '@ngrx/store';
import { AppState, CreepSkillAction } from '../../store.module';

// App dependencies
import { Skill } from '../../creep-skill';

@Component({
  selector: 'app-skill',
  templateUrl: './skill.component.html',
  styleUrls: ['./skill.component.scss']
})
export class SkillComponent {
  @Input() skill: Skill;
  @Output() increment: EventEmitter<any> = new EventEmitter<any>();

  private _readonly: boolean;

  constructor(
    private _elementRef: ElementRef,
    private _store: Store<AppState>
  ) {
    this._readonly = Boolean(_elementRef.nativeElement.attributes.readonly);
  }

  @HostBinding('class.checking') checking = false;

  @HostListener('click', [])
  onClick() {
    if (this._readonly) {
      return;
    }

    try {
      this.skill.incLevel();
      this._store.dispatch(new CreepSkillAction(this.skill));

      this.checking = true;
      setTimeout(() => this.checking = false, 1000);
    } catch (e) {
      // Ignore.
    }
  }

  get isSelected(): number {
    return this.skill.level;
  }

  get isAvailable(): boolean {
    return this.skill.upgradeAvailable();
  }

  get isReadonly(): boolean {
    return !this.skill.creepRef.upgradeAvailable();
  }

  get requiredLevel() {
    return this.skill.requiredCreepLevel();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/skill.component/skill.component.ts